export default {
  message: {
    "error": "اوه! چیزی اشتباه پیش رفت.",
    "Sorrysomeerrorsoccurred": "یک خطای غیرمنتظره اتفاق افتاده است. می‌توانید سعی کنید زبان را تغییر دهید یا برنامه را ببندید و دوباره راه‌اندازی کنید.",
    "quit": "خروج",
    "language": "زبان",
    "Youcanchangethelanguagehere": "شما می‌توانید زبان را در اینجا تغییر دهید!",
    "current": "فعلی",
    "home": "خانه",
    "friends": "دوستان",
    "wallet": "کیف پول",
    "aboutus": "درباره ما",
    "Sharewithfriends": "به اشتراک گذاری با دوستان",
    "copyFailure": "کپی ناموفق",
    "copySuccess": "کپی موفق",
    "Claimreward": "دریافت پاداش",
    "DailyLogin": "ورود روزانه",
    "noInvitationsYet": "هنوز دعوتی وجود ندارد",
    "LoadMore": "بارگذاری بیشتر",
    "WatchAD": "تماشا کردن آگهی",
    "continue": "ادامه",
    "Congratulations": "تبریک",
    "MyFriends": "دوستان من",
    "Invitefriends": "دعوت از دوستان",
    "Invitepremiumfriends": "دعوت از دوستان پریمیوم",
    "DailyTasks": "کارهای روزانه",
    "inviteDesc": "+{num} ${name} برای هر دوستی که دعوت کنید",
    "DailyTasksDesc": "وظایف را کامل کنید تا Airdrop بیشتری دریافت کنید",
    "SponsorsandPartners": "حامی‌ها و شرکا",
    "Receivingwallet": "کیف پول دریافتی",
    "Enterwalletaddress": "آدرس کیف پول {name} را وارد کنید",
    "Claim": "دریافت",
    "Booster": "تقویت‌کننده",
    "RentPeriod": "مدت اجاره",
    "days30": "30 روز",
    "Dailyprofit": "سود روزانه",
    "Totalprofit": "سود کل",
    "Quantity": "مقدار",
    "RentPrice": "قیمت اجاره",
    "RentMiner": "اجاره ماینر",
    "Insufficient": "دعوت‌کنندگان کافی نیستند",
    "InsufficientMsg": "شما نیاز دارید تا {num} دوست دعوت کنید تا اکسسوری‌های بیشتری به دست آورید.",
    "Settings": "تنظیمات",
    "copyid": "کپی شناسه",
    "UpgradeSuccessfully": "ارتقا با موفقیت انجام شد",
    "Name": "نام",
    "userinfo": "اطلاعات کاربری",
    "disconnect": "قطع ارتباط",
    "Startmining": "شروع به استخراج",
    "Welcome": "به {name} خوش آمدید",
    "Withdrawal": "برداشت",
    "Minimumamount": "حداقل مبلغ",
    "Networkfee": "هزینه شبکه",
    "Enteramount": "مقدار را وارد کنید",
    "Submit": "ارسال",
    "MinimumTip": "مقدار برداشت خیلی کم است. حداقل مقدار برداشت: {num}",
    "MaximumTip": "مقدار کافی نیست، حداکثر مقدار قابل برداشت: {num}",
    "SubmittedTip": "ارسال شد، انتظار می‌رود در عرض ۳۰-۶۰ روز کاری پردازش شود",
    "WithdrawStatus": "وضعیت",
    "Submissiontime": "زمان ارسال",
    "WithdrawAwaitTip": "* تخمین زده می‌شود ۳۰-۶۰ روز کاری طول بکشد. دعوت از دوستان بیشتر می‌تواند فرآیند بررسی را تسریع کند.",
    "Processing": "در حال پردازش",
    "Amount": "مقدار",
    "Numberoffriends": "تعداد دوستان: {now}/{limit}",
    "InviteTip": "برای اینکه اولین برداشت خود را انجام دهید، به دعوت {limit} دوستان نیاز دارید تا به اپلیکیشن استخراج بپیوندند.",
    "openonphone": "این لینک را در تلفن خود باز کنید.",
    "claimTip": "مقدار قابل جمع‌آوری خیلی کم است. حداقل مقدار قابل جمع‌آوری: {num}",
    "WalletBalance": "بالانس کیف پول",
    "Withdraw": "برداشت",
    "SetWalletAddress": "تنظیم آدرس کیف پول",
    "WithdrawalRecord": "سابقه برداشت",
    "Norecords": "بدون سابقه",
    "Whatis": "{name} چیست؟",
    "All": "همه",
    "save": "ذخیره",
    "successWithdrawal": "اسکن با موفقیت {num}",
    "secondsago": "{time} ثانیه پیش",
    "Loading": "در حال بارگذاری...",
    "PaymentConfirming": "در حال بررسی وضعیت تراکنش...",
    "Check": "بررسی",
    "CheckFail": "تراکنش تکمیل نشده است. لطفاً ۵ ثانیه دیگر بررسی کنید.",
    "Addname": "به نام خود '{name}' را اضافه کنید",
    "Restattcheck": "اپلیکیشن را ریستارت کنید تا بررسی کنید",
    "Copyname": "نسخه‌برداری '{name}'",
    "SubmissionFailed": "ارسال ناموفق، لطفاً بعداً دوباره تلاش کنید",
    "WithdrawalReview": "بررسی برداشت",
    "WebWithdrawAwaitTip": "* تخمین زده می‌شود ۲۴-۴۸ ساعت طول بکشد. دعوت از دوستان بیشتر می‌تواند فرآیند بررسی را تسریع کند.",
    "Success": "موفقیت",
    "Rejection": "ردشدن",
    "WebSubmittedTip": "ارسال شد، ما آن را در اسرع وقت پردازش خواهیم کرد.",
    "select_payment_method": "روش پرداخت را انتخاب کنید",
    "total_amount": "مجموع مبلغ",
    "next_step": "مرحله بعدی",
    "creating_order": "در حال ایجاد سفارش...",
    "order_created": "سفارش ایجاد شد",
    "order_status": "وضعیت سفارش",
    "order_id": "شناسه سفارش",
    "order_amount": "مقدار سفارش",
    "order_status_desc": "شرح وضعیت سفارش",
    "payment_cancelled": "پرداخت لغو شد",
    "opening_payment": "در حال باز کردن پرداخت...",
    "payment_success": "پرداخت موفقیت‌آمیز بود",
    "payment_failed": "پرداخت ناموفق بود",
    "payment_pending": "پرداخت در حال انتظار است",
    "payment_processing": "پرداخت در حال پردازش است",
    "create_order_failed": "ایجاد سفارش ناموفق بود",
    "creating_ton_order": "در حال ایجاد سفارش TON...",
    "check_payment_status": "در حال بررسی وضعیت پرداخت...",
    "use_ton_payment": "استفاده از پرداخت TON",
    "connect_wallet": "اتصال کیف پول",
    "start_transaction": "شروع تراکنش",
    "address": "آدرس",
    "amount_ton": "مقدار TON",
    "copy": "کپی",
    "comment_memo": "یادداشت نظرات",
    "comment_memo_desc": "لطفا یادداشت نظرات را وارد کنید",
    "comment_memo_placeholder": "وارد کردن یادداشت نظرات",
    "amount": "مقدار",
    "wallet_address": "آدرس کیف پول",
    "you_can_choose_to_connect_wallet_to_pay": "شما می توانید کیف پول را برای پرداخت متصل کنید",
    "or_manually_transfer_to_the_above_address": "یا به صورت دستی به آدرس بالا انتقال دهید (توجه داشته باشید که مقدار و یادداشت باید دقیقاً یکسان باشند)",
    "transaction_success": "تراکنش موفق",
    "transaction_failed": "تراکنش ناموفق بود",
    "transaction_error": "خطای تراکنش",
    "transaction_status": "وضعیت تراکنش",
    "transaction_id": "شناسه تراکنش",
    "transaction_amount": "مقدار تراکنش",
    "transaction_status_desc": "توضیحات وضعیت تراکنش",
    "miner_detail": "جزئیات ماینر",
    "rent_period": "مدت اجاره",
    "days": "{days} روز",
    "daily_yield": "بازده روزانه",
    "total_yield": "بازده کلی",
    "invite_friends": "دعوت از دوستان",
    "price": "قیمت",
    "rent": "اجاره",
    "free_claim": "جمع آوری رایگان",
    "redeem": "بستانکاری",
    "buy": "اجاره",
    "invite_friends_not_enough": "دعوت از دوستان کافی نیست",
    "redeem_success": "بستانکاری موفق",
    "redeem_failed": "بستانکاری ناموفق بود",
    "rent_success": "اجاره موفق",
    "rent_failed": "اجاره ناموفق بود",
    "TotalPower": "قدرت کل",
    "MaxQuantity": "حداکثر مقدار رسید",
    "Running": "در حال اجرا",
    "Stop": "متوقف کردن",
    "InviteTipFirst": "برای برداشت اولیه خود، نیاز به دعوت {limit} دوست دارید تا به اپلیکیشن ماینینگ بپیوندند.",
    "Withdrawalunlock": "آزادسازی برداشت",
    "Close": "بستن",
    "Delivering": "تحویل دادن",
    "Duetothelargenumber": "با توجه به تعداد زیاد دریافت‌کنندگان، انتظار می‌رود ایردراپ شما در ۱۵-۲۰ روز کاری به دستتان برسد",
    "WithdrawalunlockTip": "شما به {num} دوست دعوت‌شده نیاز دارید تا وظایف را تکمیل کنید/کیف پول‌ها را متصل کنید تا برداشت آزاد شود",
    "mining_title": "روبات",
    "Upgrade": "به‌روزرسانی",
    "partner": "شریک",
    "faq": "سوالات متداول",
    "task": "وظیفه",
    "OpenRobot": "ربات را باز کن",
    "MyRobot": "ربات من",
    "Level": "سطح",
    "Commission": "کمسیون",
    "DirectFriends": "دوستان مستقیم",
    "Feedback": "بازخورد",
    "Pleaseenteryouremailaddress": "لطفاً آدرس ایمیل خود را وارد کنید",
    "Inputfeedbackcontent": "متن بازخورد را وارد کنید",
    "Submitfeedback": "ارسال بازخورد",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "بازخورد با موفقیت ارسال شد، از شما بابت بازخورد ارزشمندتان سپاسگزاریم",
    "Feedbacksubmissionfailed,pleaseretriy": "ارسال بازخورد ناموفق بود، لطفاً دوباره تلاش کنید",
    "Addressformaterror": "خطای فرمت آدرس",
    "Readclipboardfailed": "خواندن کلیپ بورد ناموفق بود",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "شما امروز قبلاً بازخورد داده‌اید، لطفاً فردا برگردید",
    "Record": "ضبط",
    "Newuserguidance": "نمایش تور خوش‌آمدگویی",
    "Usetonwallet": "استفاده از کیف پول TON",
    "Reward": "پاداش",
    "Connectwallet": "اتصال کیف پول",
    "Notconnected": "متصل نشده",
    "Disconnect": "قطع اتصال",
    "AboutTAI": "جزئیات توکن",
    "WithdrawalRecordDesc": "سوابق برداشت",
    "StartAItrading": "شروع معامله AI",
    "Next": "بعدی",
    "Start": "شروع",
    "WithdrawalSuccess": "برداشت موفق",
    "WithdrawalFail": "برداشت ناموفق",
    "Max": "حداکثر",
    "WithdrawalRecords": "سوابق برداشت",
    "Commissionrules": "قوانین کمیسیون",
    "Mycommission": "کمیسیون من",
    "Shop": "فروشگاه",
    "BuyDifferentAIrobots": "با دستگاه‌های محاسباتی برای اسکن‌های سریع‌تر ارتقا دهید!",
    "CurrentRunningAIrobots": "روبات‌های هوش مصنوعی در حال اجرا",
    "DailyProfit": "سود روزانه",
    "Buy": "خرید",
    "ValidityPeriod": "مدت اعتبار",
    "Days": "روز",
    "Price": "قیمت",
    "APY": "APY",
    "NoRobot": "بدون قدرت محاسباتی",
    "RemainingTime": "زمان باقی‌مانده",
    "InviteandEarn": "دعوت کنید و کسب درآمد کنید",
    "InvitDec": "دوستان خود را دعوت کنید تا به تجارت هوش مصنوعی بپیوندند و همراه با هم کمیسیون‌های USDT و توکن‌های Airdrop کسب کنید!",
    "ShareToGroups": "به گروه‌ها به اشتراک بگذارید",
    "Select_payment_method": "روش پرداخت را انتخاب کنید",
    "twa_pay_tip_with_memo": "لطفاً اطمینان حاصل کنید که آدرس، مقدار و یادداشت برای انتقال هماهنگ هستند.",
    "twa_pay_tip": "لطفاً اطمینان حاصل کنید که آدرس و مقدار برای انتقال صحیح هستند.",
    "twa_pay_tip_placeholder": "یادداشت نظر را وارد کنید",
    "twa_pay_tip_placeholder_with_memo": "یادداشت نظر را با یادداشت وارد کنید",
    "twa_pay_tip_placeholder_without_memo": "یادداشت نظر را بدون یادداشت وارد کنید",
    "twa_pay_tip_placeholder_with_memo_placeholder": "یادداشت نظر را با یادداشت وارد کنید",
    "twa_pay_tip_placeholder_without_memo_placeholder": "یادداشت نظر را بدون یادداشت وارد کنید",
    "realtime_ai": "معاملات AI در زمان واقعی",
    "check_transaction_status": "وضعیت تراکنش را بررسی کنید",
    "transaction_wait": "تراکنش در حال پردازش است. می‌توانید از برنامه خارج شوید. یک پیام به شما اطلاع خواهد داد زمانی که این کار تکمیل شود.",
    "Pleaseenteravalidemailaddress": "لطفاً یک آدرس ایمیل معتبر وارد کنید",
    "max_robot_tip": "به حد خرید رسیدید — برنامه دیگری را برای ادامه معامله امتحان کنید!",
    "connectFailure": "اتصال به کیف پول ناموفق بود",
    "connectSuccess": "اتصال به کیف پول موفقیت آمیز بود",
    "PayNow": "هم اکنون پرداخت کنید",
    "min_withdrawal_amount": "حداقل مبلغ برداشت {num} {coin_name} است",
    "max_withdrawal_amount": "حداکثر مبلغ برداشت {num} {coin_name} است",
    "balance_not_enough": "شما برای این برداشت موجودی کافی ندارید.",
    "Numberofgroups": "تعداد گروه‌ها: {now}/{limit}",
    "Withdraw_success": "برداشت با موفقیت انجام شد",
    "allProfit": "جمع کل سود",
    "AnnualProfit": "سود سالانه",
    "ScanWallet": "کیف پول را اسکن کنید",
    "wallet_check": "wallet_check",
    "Found": "یافت شد",
    "ScanSpeed": "سرعت اسکن",
    "MyComputingPower": "محاسبات",
    "Scanning": "در حال اسکن!",
    "WithdrawDetail": "جزئیات برداشت",
    "ScanSuccess": "نرخ موفقیت اسکن شما افزایش یافته است!",
    "TaskDescription": "وظایف را کامل کنید تا نرخ موفقیت اسکن خود را افزایش دهید!",
    "InitializingMiningSystem": "در حال راه‌اندازی سیستم اسکن...",
    "NoWithdrawalRecord": "هیچ رکورد برداشت وجود ندارد",
    "Invite": "دعوت‌های مورد نیاز",
    "Free": "رایگان",
    "Confirm": "تأیید",
    "RefreshTasks": "به‌روزرسانی وظایف",
    "NumberofGroups": "تعداد گروه‌ها: {now}/{limit}",
    "SendMessage": "ارسال پیام",
    "NumberofShares": "تعداد سهام: {now}/{limit}",
    "NumberofTasks": "تعداد وظایف: {now}/{limit}",
    "CompleteTask": "انجام وظیفه",
    "Accelerated": "شتاب‌زده",
    "Accelerated_withdrawals_success": "برداشت‌های شتاب‌زده با موفقیت",
    "GoBuy": "برو خرید کن",
    "SpeedUpScan": "سرعت بخشیدن",
    "Earnings": "درآمد",
    "learnMore": "بیشتر یاد بگیرید",
    "claimSuccess": "جوایز با موفقیت دریافت شد",
    "claimFailed": "دریافت ناموفق، لطفاً دوباره تلاش کنید",
    "noDividends": "هیچ سودی برای دریافت وجود ندارد",
    "dividendsInfoFallback": "دوستان را دعوت کنید تا جوایز معرفی کسب کنید"
}};